import { Social } from '@/types/Configuration'

import { usePageContext } from '@/contexts/PageContext'

import Icon, { IconName } from '@/components/atoms/Icon'
import GridColumn from '@/components/atoms/GridColumn'
import Container from '@/components/atoms/Container'
import Grid from '@/components/atoms/Grid'
import Flex from '@/components/atoms/Flex'

import styles from './Footer.module.scss'
import FooterMenu from './FooterMenu'
import { FooterMenuItem } from './FooterMenu/FooterMenu.types'

const Footer = () => {
  const { footer } = usePageContext()

  if (!footer) return null
  const { banner, socials, references, menu, policy } = footer
  const { totalSpan = 0, items: normalizedMenu = [] } = menu ?? {}

  return (
    <footer className={styles.footer}>
      {normalizedMenu.length > 0 && (
        <div className={styles.mainFooter}>
          <Grid gap='1.5rem'>
            {normalizedMenu.map(
              (
                {
                  span,
                  ...rest
                }: {
                  span: number
                  headerLabel: string
                  main: FooterMenuItem[]
                },
                idx: number
              ) => (
                <GridColumn
                  key={idx}
                  sm={12}
                  span={span}
                >
                  <FooterMenu
                    key={idx}
                    {...rest}
                  />
                </GridColumn>
              )
            )}

            {socials?.length > 0 && (
              <GridColumn
                sm={12}
                span={12 - totalSpan}
              >
                <ul className={styles.socials}>
                  {socials.map(
                    ({ href, target, label, icon }: Social, idx: number) => (
                      <li key={idx}>
                        <a
                          href={href}
                          target={target}
                          aria-label={label}
                        >
                          <Icon iconName={icon as IconName} />
                        </a>
                      </li>
                    )
                  )}
                </ul>
              </GridColumn>
            )}
          </Grid>
        </div>
      )}
      {policy && (
        <div className={styles.legalFooter}>
          <Container>
            <Flex
              className={styles.legalFooterContent}
              gap='2rem'
            >
              {references?.map((text: string) => <p key={text}>{text}</p>)}

              {policy.map(({ ...rest }, idx: number) => (
                <FooterMenu
                  key={idx}
                  {...rest}
                />
              ))}
            </Flex>
          </Container>
        </div>
      )}
      {banner && (
        <div className={styles.messageFooter}>
          <Container>
            <p>{banner.text}</p>
          </Container>
        </div>
      )}
    </footer>
  )
}

export default Footer
